<script setup lang="ts">
import ActionRender from "./ActionRender.vue";
import { ActionModelValue } from "./_types";
import MLayoutStack from "../MLayoutStack/MLayoutStack.vue";

withDefaults(
  defineProps<{
    modelValue?: ActionModelValue | Record<string, any> | null;
    ghost?: boolean;
    small?: boolean;
    iconOnly?: boolean;
    useQuasar?: boolean;
  }>(),
  { ghost: true, useQuasar: true },
);
</script>
<template>
  <MLayoutStack v-if="Array.isArray(modelValue)" horizontal gap="1">
    <ActionRender
      v-for="(item, i) in modelValue"
      :key="`action-key-${item.label}-${i}`"
      :model-value="item"
      :ghost="ghost"
      :small="small"
      :use-quasar="useQuasar"
    />
  </MLayoutStack>
  <ActionRender
    v-else-if="modelValue"
    :model-value="modelValue"
    :ghost="ghost"
    :small="small"
    :icon-only="iconOnly"
    :use-quasar="useQuasar"
  />
</template>
